import React, { useState } from "react";
import "./ServiceAccordion.css";
import { MdOutlineLocalLaundryService } from "react-icons/md";
import { GiSchoolBag, GiRunningShoe } from "react-icons/gi";
import { TbWashPress } from "react-icons/tb";

import { FaTshirt } from "react-icons/fa";
import "./ServiceAccordion.css";
export default function ServiceAccordion() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const DirhamIcon = () => (
    <svg width="14" height="14" viewBox="0 0 100 100">
      <path
        d="M20 10 L20 90 Q80 90 80 50 Q80 10 20 10"
        stroke="#5a0b64"
        strokeWidth="10"
        fill="none"
      />
      <line
        x1="20"
        y1="40"
        x2="100"
        y2="40"
        stroke="#5a0b64"
        strokeWidth="10"
      />
      <line
        x1="20"
        y1="60"
        x2="100"
        y2="60"
        stroke="#5a0b64"
        strokeWidth="10"
      />
    </svg>
  );
  return (
    <div className="accordion-wrapper">
      {/* WASH & FOLD */}
            <h2 className="expertise-title">Service Price Sections</h2>

      <div className="accordion-card mt-5">
        <div className="accordion-header" onClick={() => toggle(0)}>
          <div className="left">
            {/* <MdOutlineLocalLaundryService
              className="icon"
              style={{ color: "#6b005f" }}
            /> */}
            <span style={{ marginBottom: "5px" }}>Pressing Only Service</span>
          </div>
          <span className="symbol">{openIndex === 0 ? "−" : "+"}</span>
        </div>

        {openIndex === 0 && (
          <div className="accordion-body">
              <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}>

            <table class="table table-bordered ">
              <thead className="">
                <tr style={{ textTransform: "uppercase" }}>
                  <th style={{ color: "" }}>Pressing Only</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Military Uniform</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Night Wear Men</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pants</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pants/Jeans</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>

                <tr>
                  <td> Pyjama pants</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shorts</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit 2pc</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit 3pc</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit Jacket</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> T-shirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Blouse</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Blouse (Sari)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Dupatta</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Jumpsuit</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Night Wear Ladies</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pants/Jeans</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Party Blouse S</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Party Dress</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shorts</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Skirt</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Skirt Long</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Skirt Pleated</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> T-shirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Abaya basic</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Gathra</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kandura</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kandura Wool</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Khamis</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kurta womens</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Lungi</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Sari Delicate</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Sari Normal</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Scarf / Sheaila Normal</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shalwar</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shalwar Khamis 2pcs</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar Khamis 3pcs</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Sherwani</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Bedsheet</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Bedsheet Double</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Coat</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Jacket</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Overcoat</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pullover</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pyjama Big</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pyjama Single</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit Karate</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit Sport</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Trouser Cotton</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>

                <tr>
                  <td> Military Uniform</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Night Wear Men</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pants</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pants/Jeans</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pyjama pants</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shirt</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shorts</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> T-shirt</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Blouse</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Blouse (Sari)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Dupatta</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Jumpsuit</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Night Wear Ladies</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pants/Jeans</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Party Blouse S</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Party Dress</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shorts</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Skirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Skirt Long</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Skirt Pleated</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> T-shirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Bedsheet</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Bedsheet Double</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Coat</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Jacket</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Overcoat</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pullover</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pyjama Big</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Pyjama Single</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit Karate</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit Sport</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Trouser Cotton</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>

                <tr>
                  <td> Abaya</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Gathra</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kandura</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kandura Wool</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Khamis</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kurta Women</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Lungi</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Sari Delicate</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Sari Normal</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Scarf / Sheaila Normal</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shalwar</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shalwar Khamis 2pcs</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shalwar Khamis 3pcs</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Sherwani</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>

                <tr>
                  <td> Kids Kandura</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids Shirt</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Lab Coat</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids T shirt</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Under Baniyan (Vest)</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kandura Tie</td>
                  <td>
                    0 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit Jacket</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Jalbiya</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> plated baby dress</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> kids kandura</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Jalabiya</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Party Dress (2pcs)</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kandura - Express price</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Duvet Cover</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pillow case</td>
                  <td>
                    1.5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Ladies Dress</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Jalbiya</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Jalbiya</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids Party Dress</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Skirt</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Top</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Ladies top</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids Pant</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Bisht</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Uniform (Shirt Only)</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Petty Coat</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Transparant Skirt for Ladies</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Under Vest</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kandura - Special price</td>
                  <td>
                    2.5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Petty Coat</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Ladies Pant</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Police Uniform</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Abaya Belt</td>
                  <td>
                    0 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Abaya (2 pcs)</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Double Abaya</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Military Pant</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Military Shirt</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Overall Uniform</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids Frok</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Frok (S)</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Dress</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Gown</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Petty Coat</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids Sweater</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Helmet</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids Bed</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids Dress</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shirt</td>
                  <td>
                    1.5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Suit (2pcs)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Ehram Cloth</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pant</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Overall Uniform (B)</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Party Dress (S)</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Prayer Dress</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Abaya inar</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Dress (2pcs)</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Hijab</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Delivery Fee</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> T Shirt</td>
                  <td>
                    1.5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Kids Shirt</td>
                  <td>
                    1.5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Rupata</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Under wear</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shirt (N)</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> T Shirt (N)</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td> Shorts (N)</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        )}
      </div>

      {/*Wash & Press*/}
      <div className="accordion-card">
        <div className="accordion-header" onClick={() => toggle(1)}>
          <div className="left">
            {/* <TbWashPress className="icon" style={{ color: "#6b005f" }} /> */}
            <span>Wash & Press Price List</span>
          </div>
          <span className="symbol">{openIndex === 1 ? "−" : "+"}</span>
        </div>

        {openIndex === 1 && (
          <div className="accordion-body">
                        
            <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}>

            <table class="table table-bordered">
              <thead>
                <tr style={{ textTransform: "uppercase" }}>
                  <th>Wash & Press</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>JACKET</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Military Uniform</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pants</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shirt</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit 2pc</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit 3pc</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit Jacket</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>T-shirt</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Tie</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blouse</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blouse (Sari)</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jumpsuit</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Blouse S</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt Long</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt Pleated</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya basic</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kandura</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sari Delicate</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sari Normal</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Scarf / Sheaila Normal</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sherwani</td>
                  <td>
                    50 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Coat</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cushion cover medium</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jacket</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Lether Jacket</td>
                  <td>
                    50 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Overcoat</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sofa cover Large</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sweater</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Table mat</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Night Wear Men</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pants/Jeans</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pyjama pants</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shorts</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Dupatta</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Night Wear Ladies</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Underwear</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cap Normal</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bathing Suit</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Under Short</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Under Skirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Gathra</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kandura Wool</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kurta Women</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Lungi</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Scarf / Sheaila Delicate</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar Khamis 2pcs</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar Khamis 3pcs</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Apron</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bath towel</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bedsheet Double</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blanket Large</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blanket Small</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Comforter cover</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Door Mat</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Duvet Medium</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Duvet cover</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Handkerchief</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Mattress Protector</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pillow</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sofa Cover regular</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Face Towel</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Stuffed toy small</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit Karate</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit Sport</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cotton Trouser</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Wedding Dress</td>
                  <td>
                    200 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cap Delicate</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pillow case</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya Super Delicate</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Hood jacket</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Under vest</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Night pants</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>socks</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blanket Medium</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Kandura</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jalabiya Women</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Overall Uniform</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya Normal</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bedsheet Single</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pryer Cap</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Baniya Vest</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Duvet Large</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Dust Proof Cover</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids t Shirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids pant</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blanket Extra Large</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pillow Protector</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Duvet Small</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>School Bag Normal</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya Delicate</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Frok (Medium)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Frok (Small)</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kandura Deep Clean</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jalabiya Men</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Panty Women</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Police Reflector</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt pleated delicate</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Duvet Cover Small</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Trouser </td>
                  <td>
                    1.4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>T-Shirt</td>
                  <td>
                    1.25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jalabiya kids</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Double Abaya</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Baniyan</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Top</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Shorts</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Uniform</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Table Cloth</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Winter coat long</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Military Pant</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cotton Bag (Small)</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Heavy Bedsheet</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Baby Blanket</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Nikab ladies</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>kids Jacket</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Hand Towel</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Head Towel</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bath Robe</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Dress</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Police Uniform</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Military Shirt</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bath Towel (Big)</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Underwear</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Sweater</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Uniform (Shirt)</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Curtain (Small)</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Baby Bed</td>
                  <td>
                    35 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Baby Pillow</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Heavy Jacket</td>
                  <td>
                    {" "}
                    <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Waterproof Cover</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pillow (M)</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cloth</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Dress (M)</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bed Runner</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Military Cap</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cushion Cover</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Dress (S)</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Vest</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Safety Coat</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Curtain (M)</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Blanket</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Head Band</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids dress</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies paint</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids School Uniform</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Handkerchief</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bra</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies t shart</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ehram Cloth</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Hijab Cap</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Party Dress</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Gloves</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Head Gear</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Vest</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Frok</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Napkin</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blanket</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Rupata</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress (S)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Leggings</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kid Dress</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        )}
      </div>

      {/* Wash & Fold */}

      <div className="accordion-card">
        <div className="accordion-header" onClick={() => toggle(7)}>
          <div className="left">
        
            <span>Wash & Fold Price List </span>
          </div>
          <span className="symbol">{openIndex === 7 ? "−" : "+"}</span>
        </div>

        {openIndex === 7 && (
          <div className="accordion-body">
                        <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}>

            <table class="table table-bordered">
              <thead>
                <tr style={{ textTransform: "uppercase" }}>
                  <th>Wash & Fold Service</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody className="symbol">
                <tr>
                  <td>Cap</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cap Branded</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jacket</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Night Wear Men</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Military Uniform</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pants</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pants/Jeans</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pyjama Pants</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shirt</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shorts</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>T-shirt</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Tie</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Underwear</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya Dress</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kaftan Ladies Dress</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bathing Suit</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blouse</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blouse (Sari)</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bra</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Dupatta</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jumpsuit</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Night Wear Ladies</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pants/Jeans</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Blouse S</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shirt</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shorts</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt Long</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt Pleated</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>T-shirt</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Under Short</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Under Skirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Prayer Dress</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Prayer Mat</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Gathra</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kandura Wool</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kurta Womens</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Lungi</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sari Delicate</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sari Normal</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Scarf / Sheaila Normal</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Scarf / Sheaila Special</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar Khamis 2pcs</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar Khamis 3pcs</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sherwani</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sweater</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pyjama Big</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Stuffed Toy Small</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit Karate</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit Sport</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Trouser Cotton</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Wedding Dress</td>
                  <td>
                    150 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Military Uniform</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Night Wear Men</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pants</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pants/Jeans</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pyjama Pants</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shirt</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shorts</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>T-shirt</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Underwear</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cotton Trouser</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blouse</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blouse (Sari)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Dupatta</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jumpsuit</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Night Wear Ladies</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Blouse S</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bathing Suits</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt Long</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt Pleated</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Gathra</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kandura</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kandura Wool</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kurta Women</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Lungi</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sari Delicate</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sari Normal</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Scarf / Sheaila Delicate</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar Khamis 2pcs</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar Khamis 3pcs</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sherwani</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Apron</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bath Towel</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bedsheet Double</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Comforter Cover</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cushion Cover Medium</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Duvet Cover</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Mattress Protector</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Face Towel</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bath Rope</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>CAT Bed</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Jumpsuit</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Sweater</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Pant</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Under Vest</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids T Shirt</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Frock</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Bra</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Jeans</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Jacket</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Kandura</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Gloves</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Hat</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Socks Pair</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Table Cloth</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Dress</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jalabiya</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pillow Case</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Hand Towel</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Shorts</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Underwear</td>
                  <td>
                    1 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Night Wear</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Mattress Cover</td>
                  <td>
                    60 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Prayer Mat</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cushion Cover (B)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cushion Cover (S)</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        )}
      </div>

      {/* Dry Clean Service */}

      <div className="accordion-card">
        <div className="accordion-header" onClick={() => toggle(11)}>
          <div className="left">
            {/* <img
              src="https://5asec.ae/wp-content/uploads/2020/05/accessories-01.svg"
              alt=""
              style={{ height: "20px" }}
            /> */}
            <span>Dry Clean Price List </span>
          </div>
          <span className="symbol">{openIndex === 11 ? "−" : "+"}</span>
        </div>
        {openIndex === 11 && (
          <div className="accordion-body">
                                    <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}>

            <table class="table table-bordered">
              <thead>
                <tr style={{ textTransform: "uppercase" }}>
                  <th>Dry Clean Service</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody className="symbol">
                <tr>
                  <td>Curtain sqm</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Carpet sqm</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Apron</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bath Towel</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bedsheet Double</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blanket Large</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blanket Small</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Blanket/BedCover Children</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Comforter Cover</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Cushion Cover Medium</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Door Mat</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Duvet</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Duvet Cover</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Handkerchief</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Mattress Protector</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pillow</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sofa Cover Large</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sofa Cover Regular</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Face Towel</td>
                  <td>
                    2 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit 2pc</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit 3pc</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit Jacket</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Military Uniform</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pants</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shirt</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>T-shirt</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Tie</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sari Delicate</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Shirt</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Suit Jacket</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress Delicate</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Blouse</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt Long</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt Pleated</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies T-Shirt</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Abaya Delicate</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kandura</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sherwani Delicate</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Gathra</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Wedding Dress (Ex-Large)</td>
                  <td>
                    300 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Wedding Scalf</td>
                  <td>
                    100 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Wedding Dress (Medium)</td>
                  <td>
                    150 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress Normal (Regular Wear)</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sweter</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Baby Dress 2 pcs</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Baby Dress</td>
                  <td>
                    10.01 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Prayer Dress Ladies Regular Wear (S)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Baby Party Dress</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Hood Jacket</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pant Dryclean</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Wedding Dress Large</td>
                  <td>
                    200 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress Large</td>
                  <td>
                    100 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress Medium</td>
                  <td>
                    75 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Scarf</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sweater</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Long Jacket</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jacket</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Police Reflector</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress Normal (M)</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress Normal (L)</td>
                  <td>
                    55 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Dress</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Vest</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress (S)</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Party Dress (M)</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shirt Super Delicate</td>
                  <td>
                    65 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>T-Shirt Super Delicate</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shalwar Khamis (2pcs)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Pull Over</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Sweater</td>
                  <td>
                    7 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Shirt</td>
                  <td>
                    7 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Frok</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>hood jacket</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>jalabyia</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Panit</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Under Vest</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jumpsuit</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Suit (2pcs)</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Heavy Jacket</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jeans Short</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Scarf / Sheila</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Dress (2pcs)</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Skirt (S)</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids T-Shirt</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Top</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Vest</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Top</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Jalbiya</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Top</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Dress</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bisht for Men</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Dress (3pcs)</td>
                  <td>
                    18 <DirhamIcon />
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        )}
      </div>
      {/* Shoe CareService */}
      <div className="accordion-card">
        <div className="accordion-header" onClick={() => toggle(12)}>
          <div className="left">
            {/* <img
              src="https://5asec.ae/wp-content/uploads/2020/05/accessories-01.svg"
              alt=""
              style={{ height: "20px" }}
            /> */}
            <span>Shoe Care Price List</span>
          </div>
          <span className="symbol">{openIndex === 12 ? "−" : "+"}</span>
        </div>
        {openIndex === 12 && (
          <div className="accordion-body">
                                    <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}>

            <table class="table table-bordered">
              <thead>
                <tr style={{ textTransform: "uppercase" }}>
                  <th>Shoe Care </th>
                  <th>Price </th>
                </tr>
              </thead>
              <tbody className="symbol">
                <tr>
                  <td>Running Shoes</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Casual Shoe Delicates</td>
                  <td>
                    80 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Canvas Shoes</td>
                  <td>
                    50 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Loafers Shoes</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Oxford Shoes</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Casual Shoe N</td>
                  <td>
                    50 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Womens Sandal Delicate</td>
                  <td>
                    35 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Womens Sandal Super Delicate</td>
                  <td>
                    85 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Slip On Shoes</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Ladies Sandal Normal</td>
                  <td>
                    25 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Shoe (Boat) Mens</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Shoe</td>
                  <td>
                    60 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>All Stars Shoe</td>
                  <td>
                    35 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Casual Shoe (M)</td>
                  <td>
                    60 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Baby Shoe</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Military Boat</td>
                  <td>
                    50 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Casual Shoe (S)</td>
                  <td>
                    70 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Shoe (S)</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Sandal</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Sandal (Alt)</td>
                  <td>
                    15 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Kids Shoe (M)</td>
                  <td>
                    35 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Football Boots</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        )}
      </div>

      {/* <h2 className="expertise-title">Monthly Plans</h2> */}
      <div className="accordion-card mt-2">
        <div className="accordion-header" onClick={() => toggle(13)}>
          <div className="left">
            <span>Bag Care Price List</span>
          </div>
          <span className="symbol">{openIndex === 13 ? "−" : "+"}</span>
        </div>
        {openIndex === 13 && (
          <div className="accordion-body">
            <table class="table table-bordered">
              <thead>
                <tr style={{ textTransform: "uppercase" }}>
                  <th>Bag Care Items </th>
                  <th>Price </th>
                </tr>
              </thead>
              <tbody className="symbol">
                <tr>
                  <td>Bag Delicate</td>
                  <td>
                    80 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bag Normal</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>School Bag Normal</td>
                  <td>
                    40 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>Bag - Delicate</td>
                  <td>
                    50 <DirhamIcon />
                  </td>
                </tr>
                <tr>
                  <td>School Bag (S)</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div className="accordion-card">
        <div className="accordion-header" onClick={() => toggle(14)}>
          <div className="left">
            <span>Home Care Price List</span>
          </div>
          <span className="symbol">{openIndex === 14 ? "−" : "+"}</span>
        </div>
        {openIndex === 14 && (
          <div className="accordion-body">
                                    <div style={{ maxHeight: "400px", overflowY: "auto", overflowX: "auto" }}>

            <table class="table table-bordered">
              <thead>
                <tr style={{ textTransform: "uppercase" }}>
                  <th>HOME CARE </th>
                  <th>Price</th>
                  <th>SQUARE & METER & FEET </th>
                </tr>
              </thead>
              <tbody className="symbol">
                <tr>
                  <td>Curtain sqm</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Carpet Normal</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Table Mat</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Sofa Cover Large</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Prayer Mat</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Curtain Pressing Only</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Carpet Delicate</td>
                  <td>
                    18 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                {/* <tr>
                  <td>Curtain Normal</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr> */}
                <tr>
                  {/* <td>Curtain Special Only</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Carpet Delicate</td>
                  <td>
                    18 <DirhamIcon />
                  </td> */}
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Sofa Cover Small</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Sofa Cover Large</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Cloth Basket (Medium)</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Cloth Basket (Small)</td>
                  <td>
                    8 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Cloth Mat</td>
                  <td>
                    3 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Door Mat</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Carpet Rug</td>
                  <td>
                    5 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Kids Mattress</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Curtain Chiffon (Large)</td>
                  <td>
                    50 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Cat Dard</td>
                  <td>
                    10 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Curtain Holder</td>
                  <td>
                    0 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Curtain Delicate</td>
                  <td>
                    12 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Mattress</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Curtain Chiffon (Medium)</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Car Cover</td>
                  <td>
                    6 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Curtain Removing and Fixing Charge</td>
                  <td>
                    100 <DirhamIcon />
                  </td>
                  <td>NORMAL</td>
                </tr>
                <tr>
                  <td>Carpet for Corporate Customer</td>
                  <td>
                    5.5 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Curtain Chiffon</td>
                  <td>
                    4 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
                <tr>
                  <td>Cushion - Ex Large</td>
                  <td>
                    20 <DirhamIcon />
                  </td>
                  <td>PRICE_PER_SQUARE_METER_OR_FEET</td>
                </tr>
              </tbody>
            </table>
            </div>
          </div>
        )}
      </div>

      <div className="accordion-card">
        <div className="accordion-header" onClick={() => toggle(15)}>
          <div className="left">
            <span>Gold Package Plain</span>
          </div>
          <span className="symbol">{openIndex === 15 ? "−" : "+"}</span>
        </div>
        {openIndex === 15 && (
          <div className="accordion-body">
            <table class="table table-bordered">
              <thead>
                  <tr style={{ textTransform: "uppercase" }}>
                  <th>Package</th>
                  <th>Price</th>
                  <th>Type</th>
                </tr>
              </thead>

              <tbody className="symbol">
                <tr>
                  <td>Gold Package - 100 to 120 Pcs per week</td>
                  <td>
                    1999 <DirhamIcon />
                  </td>
                  <td>Subscriptions</td>
                </tr>

                <tr>
                  <td>Standard Package - 60 to 70 Pcs per week</td>
                  <td>
                    1399 <DirhamIcon />
                  </td>
                  <td>Subscriptions</td>
                </tr>

                <tr>
                  <td>Basic Package - 40 to 50 Pcs per week</td>
                  <td>
                    1111 <DirhamIcon />
                  </td>
                  <td>Subscriptions</td>
                </tr>

                <tr>
                  <td>12 Clothes per Bag</td>
                  <td>
                    30 <DirhamIcon />
                  </td>
                  <td>Subscriptions</td>
                </tr>

                <tr>
                  <td>24 Clothes per Bag</td>
                  <td>
                    60 <DirhamIcon />
                  </td>
                </tr>

                <tr>
                  <td>12 Clothes per Bag</td>
                  <td>
                    33 <DirhamIcon />
                  </td>
                </tr>

                <tr>
                  <td>24 Clothes per Bag</td>
                  <td>
                    24 <DirhamIcon />
                  </td>
                  <td>Subscriptions</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
  
    </div>
  );
}
